import { useState, useEffect } from "react";
import { http } from "@/lib/api";
import { useAuth } from "@/contexts/AuthContext";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { Select, SelectTrigger, SelectValue, SelectContent, SelectItem } from "@/components/ui/select";
import { toast } from "sonner";

export default function Profile() {
  const { user, updateProfile } = useAuth();
  const [form, setForm] = useState({ name: "", jenjang: "S1", university: "" });
  const [papers, setPapers] = useState([]);
  const [theses, setTheses] = useState([]);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    if (user) setForm({ name: user.name || "", jenjang: user.jenjang || "S1", university: user.university || "" });
  }, [user]);

  useEffect(() => {
    http.get("/my/papers").then(r => setPapers(r.data)).catch(()=>{});
    http.get("/my/theses").then(r => setTheses(r.data)).catch(()=>{});
  }, []);

  const save = async () => {
    setBusy(true);
    try { await updateProfile(form); toast.success("Profil disimpan"); }
    catch { toast.error("Gagal menyimpan"); }
    finally { setBusy(false); }
  };

  return (
    <div>
      <p className="text-xs uppercase tracking-widest text-[#D97706] font-semibold">Profil</p>
      <h1 className="serif text-3xl font-bold text-[#0F2922] mt-1">Profil Saya</h1>

      <div className="mt-6 kt-card p-6 max-w-2xl">
        <div className="grid md:grid-cols-2 gap-4">
          <div><Label>Nama</Label><Input value={form.name} onChange={e=>setForm({...form, name: e.target.value})} data-testid="profile-name-input" /></div>
          <div><Label>Jenjang</Label>
            <Select value={form.jenjang} onValueChange={v=>setForm({...form, jenjang: v})}>
              <SelectTrigger data-testid="profile-jenjang-select"><SelectValue/></SelectTrigger>
              <SelectContent>
                <SelectItem value="S1">S1</SelectItem><SelectItem value="S2">S2</SelectItem><SelectItem value="S3">S3</SelectItem>
              </SelectContent>
            </Select>
          </div>
          <div className="md:col-span-2"><Label>Universitas</Label><Input value={form.university} onChange={e=>setForm({...form, university: e.target.value})} data-testid="profile-university-input" /></div>
          <div><Label>Email</Label><Input value={user?.email || ""} disabled /></div>
          <div><Label>Metode Login</Label><Input value={user?.auth_method === "google" ? "Google" : "Email"} disabled /></div>
        </div>
        <Button onClick={save} disabled={busy} className="mt-4 bg-[#0F2922] hover:bg-[#173E34] text-[#FAFA96]" data-testid="profile-save-btn">Simpan</Button>
      </div>

      <div className="mt-8 grid md:grid-cols-2 gap-4">
        <div className="kt-card p-5">
          <h3 className="font-semibold text-[#0F2922]">Paper saya ({papers.length})</h3>
          <ul className="mt-2 space-y-1 text-sm text-slate-700 max-h-64 overflow-auto">
            {papers.map(p => <li key={p.paper_id}>· {p.data?.title || p.input?.topic}</li>)}
            {papers.length === 0 && <li className="italic text-slate-400">Belum ada paper</li>}
          </ul>
        </div>
        <div className="kt-card p-5">
          <h3 className="font-semibold text-[#0F2922]">Tugas akhir saya ({theses.length})</h3>
          <ul className="mt-2 space-y-1 text-sm text-slate-700 max-h-64 overflow-auto">
            {theses.map(t => <li key={t.thesis_id}>· {t.input?.field} — {t.input?.interest?.slice(0,60)}</li>)}
            {theses.length === 0 && <li className="italic text-slate-400">Belum ada</li>}
          </ul>
        </div>
      </div>
    </div>
  );
}
